import { SET_ADDITIONAL_QUERY_PARAMS } from '../actions/ActionTypes';
const initialState = {
  continueSetup: false
};
export default function additionalQueryParams(state = initialState, action) {
  const {
    payload
  } = action;
  switch (action.type) {
    case SET_ADDITIONAL_QUERY_PARAMS:
      return Object.assign({}, state, {
        continueSetup: payload.continueSetup
      });
    default:
      return state;
  }
}